module.exports = __webpack_public_path__ + "img/select36.89481440.png";